import { projects } from './siteData';

// Local tools are windows; external shortcuts preserve the desktop in a new tab.
const projectDestinations = {
  echospeak: 'https://ty0x7.github.io/EchoSpeak/',
  nosignal: '/work/nosignal',
};

export const desktopApps = [
  { id: 'ledger', title: 'Ledger', icon: 'ledger', description: 'Public addresses' },
  { id: 'connections', title: 'Connections', icon: 'terminal', description: 'Link terminal' },
  ...projects.filter(project => !project.hidden).map(project => ({
    id: `project:${project.id}`, title: project.title, icon: 'project', iconSrc: project.appIcon,
    desktop: true,
    description: project.id === 'nosignal' ? 'Project file' : 'Project website',
    href: projectDestinations[project.id] || project.liveUrl || project.link,
    aliases: [project.id],
    project,
  })),
];
